import axios from "axios";

const API = process.env.REACT_APP_API_GO;

export const getOAList = async (filters) => {
	const params = {
		page: Number(filters.page || 1),
		quantity: Number(filters.per_page || 20),
		estate_parent_id: filters.estate_parent_id || "",
		estate_id: filters.estate_id || "",
		search: filters.search || "",
		parameter: filters.parameter || "",
		status: (filters.status || []).filter(Boolean).join(","),
		type: (filters.type || []).filter(Boolean).join(","),
		internal_code: filters.internal_code || "",
		business_id: filters.business_id || "",
		date_start: filters.date_start || "",
		date_end: filters.date_end || "",
		show_detail: true,
		show_business_center: true,
		show_machinery: true,
		include_ids: true,
		include_tooltip: true,
	};

	const { data } = await axios.get(`${API}/app/planning/order_application`, { params });
	return data;
};

export const duplicateOA = async ({ app_order_ids, filters = {} }) => {
	const { data } = await axios.post(`${API}/app/planning/order_application/duplicate`, {
		app_order_ids,
		filters: {
			page: Number(filters.page || 1),
			per_page: Number(filters.per_page || 20),
			estate_parent_id: filters.estate_parent_id || "",
			estate_id: filters.estate_id || "",
			search: filters.search || "",
			parameter: filters.parameter || "",
			status: (filters.status || []).filter(Boolean).join(","),
			type: (filters.type || []).filter(Boolean).join(","),
			internal_code: filters.internal_code || "",
			business_id: filters.business_id || "",
			date_start: filters.date_start || "",
			date_end: filters.date_end || "",
		},
	});
	return data;
};

export const getOADocuments = async ({ external_id, related_table = "application_orders" }) => {
	const params = {
		related_table,
		external_id,
	};

	const { data } = await axios.get(`${API}/app/storage/files`, { params });
	return data?.data || [];
};

export const approveOA = async ({ oa_id }) => {
	const { data } = await axios.post(`${API}/app/planning/order_application/approve`, { oa_id });
	return data;
};

export const rejectOA = async ({ oa_id }) => {
	const { data } = await axios.post(`${API}/app/planning/order_application/reject`, { oa_id });
	return data;
};

export const finishOA = async ({ oa_id }) => {
	const { data } = await axios.post(`${API}/app/planning/order_application/finish`, { oa_id });
	return data;
};

export const returnStateOA = async ({ oa_id }) => {
	const { data } = await axios.post(`${API}/app/planning/order_application/return_state`, { oa_id });
	return data;
};

export const checkStatusOA = async ({ oa_id }) => {
	const { data } = await axios.post(`${API}/app/planning/order_application/check_status`, { oa_id });
	return data;
};

export const deleteOA = async ({ oa_id }) => {
	const { data } = await axios.post(`${API}/app/planning/order_application/delete`, { oa_id });
	return data;
};

export const getOAConsumptionAvailability = async (oaId) => {
	const { data } = await axios.get(`${API}/app/planning/order_application/${oaId}/consumption/availability`);
	return data;
};

export const consumeOAProductLine = async ({ oa_id, detail_id }) => {
	const { data } = await axios.post(`${API}/app/planning/order_application/${oa_id}/consumption/${detail_id}`);
	return data;
};

export const getOALookups = async () => {
	const { data } = await axios.get(`${API}/app/planning/order_application/lookups`);
	return data;
};
